import React, { Component } from 'react';
import { reportGlobalError } from './sendServerException';
import NetworkApiFailures from '../../components/popup/popup-components/NetworkApiFailures';
const STORAGE_KEY = 'exception_generated_from_boundary';

// Save error to localStorage queue
function pushError(errorData) {
    const errors = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    const isDuplicate = errors.some(e => e.message === errorData.message);
    if (!isDuplicate) {
        errors.push(errorData);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(errors));
    }
}

// Send and clear errors
function startErrorReportingLoop() {
    if (startErrorReportingLoop.started) return;
    startErrorReportingLoop.started = true;
    const reportErrors = () => {
        const errors = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
        if (errors.length > 0) {
            reportGlobalError({
                exception: errors,
                username: localStorage.getItem('username') !== 'undefined' && localStorage.getItem('username') !== null
                    ? localStorage.getItem('username')
                    : null,
            });
            localStorage.removeItem(STORAGE_KEY);
        }
    };
    reportErrors();
    setInterval(reportErrors, 300000); // every 5 minutes
}

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    // Send and clear errors
    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    // Called on exception 
    componentDidCatch(error, errorInfo) {
        this.setState({ hasError: true });

        // Construct error message safely
        let errorMessage = "Unknown error";
        try {
            if (error instanceof Error) {
                errorMessage = `${error.name}: ${error.message}`;
            } else if (typeof error === 'object') {
                errorMessage = JSON.stringify(error, null, 2);
            } else {
                errorMessage = String(error);
            }
        } catch (e) {
            errorMessage = "Unserializable error";
        }

        // Alert readable error (for debugging — remove in production)
        console.log("Error: " + errorMessage);
        console.log("Info: " + (errorInfo?.componentStack || "No component stack"));

        // Log to console for stack visibility
        console.log("Caught error:", error);
        console.log("Error stack:", error?.stack);
        console.log("Component stack:", errorInfo?.componentStack);

        // Collect error data for reporting
        const errorData = {
            username: localStorage.getItem('username') || null,
            message: errorMessage,
            stack: error?.stack || null,
            componentStack: errorInfo?.componentStack || null,
            userAgent: navigator.userAgent,
        };

        // Store and send error
        pushError(errorData);
        startErrorReportingLoop();
    }


    render() {
        if (this.state.hasError) {
            window.dispatchEvent(new CustomEvent("showInvalidApiResponseModal", {
                detail: {
                    message: "Invalid API response",
                    payload: null,
                }
            }));
            return null;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
